import React, {
  ReactNodeArray,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import styled, { css } from 'styled-components';
import { GetScrollEventsResponseType } from '../../../api/pageAnalytics/uxAnalytics/scroll/type';
import testpageimg from './testpage.png';

const Component = styled.div`
  position: relative;
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
`;

const PageScreenShotImg = styled.img`
  position: relative;
  width: 100%;
  z-index: 0;
`;

const ScreenShotImgBlur = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  background-color: black;
  z-index: 10;
`;

const HeatmapWrapper = styled.div`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 20;
  display: flex;
  flex-direction: column;
`;

const HeatmapStopGradient = styled.stop<{ $user_rate: number }>`
  ${(props) => {
    let linear_gradient = '';

    if (props.$user_rate > 94) {
      linear_gradient = props.theme.colors.heatmap01;
    } else if (props.$user_rate > 88) {
      linear_gradient = props.theme.colors.heatmap02;
    } else if (props.$user_rate > 82) {
      linear_gradient = props.theme.colors.heatmap03;
    } else if (props.$user_rate > 76) {
      linear_gradient = props.theme.colors.heatmap04;
    } else if (props.$user_rate > 70) {
      linear_gradient = props.theme.colors.heatmap05;
    } else if (props.$user_rate > 64) {
      linear_gradient = props.theme.colors.heatmap06;
    } else if (props.$user_rate > 58) {
      linear_gradient = props.theme.colors.heatmap07;
    } else if (props.$user_rate > 52) {
      linear_gradient = props.theme.colors.heatmap08;
    } else if (props.$user_rate > 46) {
      linear_gradient = props.theme.colors.heatmap09;
    } else if (props.$user_rate > 40) {
      linear_gradient = props.theme.colors.heatmap10;
    } else if (props.$user_rate > 34) {
      linear_gradient = props.theme.colors.heatmap11;
    } else if (props.$user_rate > 28) {
      linear_gradient = props.theme.colors.heatmap12;
    } else if (props.$user_rate > 22) {
      linear_gradient = props.theme.colors.heatmap13;
    } else if (props.$user_rate > 16) {
      linear_gradient = props.theme.colors.heatmap14;
    } else if (props.$user_rate > 10) {
      linear_gradient = props.theme.colors.heatmap15;
    } else {
      linear_gradient = props.theme.colors.heatmap15;
    }

    return css`
      stop-color: ${linear_gradient};
    `;
  }}
`;

const HeatmapBarItem = styled.div<{ $height: number; $width: number }>`
  height: ${(props) => props.$height}px;
  width: ${(props) => props.$width}%;
  border-bottom: 1px solid black;
  z-index: 0;
`;

const HeatmapSVG = styled.svg`
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
`;

const TooltipWrapper = styled.div<{ $isTooltipOverHalf: boolean }>`
  position: absolute;
  right: 24px;
  height: 99px;
  width: 211px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 8px;
  z-index: 10;
  &:after {
    position: absolute;
    content: '';

    ${(props) => {
      if (props.$isTooltipOverHalf) {
        return css`
          bottom: 0px;
          left: 12px;
          transform: translate(0%, 100%);
          border-top: 8px solid white;
          border-bottom: 8px solid transparent;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
        `;
      }
      return css`
        top: 0px;
        left: 12px;
        transform: translate(0%, -100%);
        border-bottom: 8px solid white;
        border-top: 8px solid transparent;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      `;
    }}
  }
`;

const TooltipItem = styled.div`
  width: 100%;
  height: 17px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const TooltipItemTitle = styled.div`
  font-family: 'RobotoR', 'NotoKrR';
  font-size: 12px;
  color: ${(props) => props.theme.colors.grey600};
`;

const TooltipItemValue = styled.div`
  font-family: 'RobotoB', 'NotoKrB';
  font-size: 12px;
  color: ${(props) => props.theme.colors.grey800};
`;

const CrossHair = styled.div`
  position: absolute;
  width: 100%;
  border: dashed 2px #fafbc9;
  z-index: 20;
`;

interface MouseScrollHeatmapProps {
  pageId: string;
  data: GetScrollEventsResponseType['payload'] | null;
}

const MouseScrollHeatmap = ({ data, pageId }: MouseScrollHeatmapProps) => {
  const ComponentEl = useRef<HTMLDivElement>(null);
  const CrossHairEl = useRef<HTMLDivElement>(null);
  const TooltipEl = useRef<HTMLDivElement>(null);
  const pageScreenshotImg = useRef<HTMLImageElement>(null);
  const [isPageScreenshotImgLoad, setIspageScreenshotImgLoad] = useState(false);
  const [gradientHeight, setGradientHeight] = useState(0);
  const [gradientWidth, setGradientWidth] = useState(0);
  const [barHeight, setBarHeight] = useState(0);
  const [lastBarHeight, setLastBarHeight] = useState(0);
  const [tooltipInfo, setTooltipInfo] = useState({
    value1: 0,
    value2: 0,
    value3: 0,
  });
  const [barCnt, setBarCnt] = useState(1);
  const [pageHeight, setpageHeight] = useState(1);
  const [isTooltipOverHalf, setIsTooltipOverHalf] = useState(false);

  const [averageHeightToRenderPixel, setAverageHeightToRenderPixel] = useState(
    0
  );

  const averageHeight = 900;

  const printHeatmapGradient = useMemo(() => {
    const result: ReactNodeArray = [];
    const stopGradientArr: ReactNodeArray = [];
    const user_rate_arr: number[] = [];
    if (isPageScreenshotImgLoad && data) {
      data.heatmap.forEach((element, index) => {
        stopGradientArr.push(
          <HeatmapStopGradient
            offset={`${index + 1}%`}
            $user_rate={element.rate}
          />
        );
        user_rate_arr.push(element.rate);
      });

      let sumHeight = 0;
      let d = 'M';

      data.scroll_usability.forEach((element, index) => {
        const realWidth = gradientWidth * (element.view_rate / 100);

        const pointer = `0,${sumHeight} ${realWidth},${sumHeight} ${realWidth},${
          sumHeight + barHeight
        } ${0},${sumHeight + barHeight} `;

        d += pointer;

        sumHeight += barHeight;

        if (data.scroll_usability.length - 1 === index) {
          d += 'z';
        }
      });

      result.push(
        <HeatmapSVG>
          <defs>
            <linearGradient
              id="voda_scroll_heatmap_linearGradient"
              x1="0%"
              y1="0%"
              x2="0%"
              y2="100%"
            >
              {stopGradientArr}
            </linearGradient>
          </defs>
          <path
            d={d}
            fill="url(#voda_scroll_heatmap_linearGradient)"
            fillOpacity="0.8"
          />
        </HeatmapSVG>
      );
    }

    return result;
  }, [barHeight, data]);

  const printHeatmapBar = useMemo(() => {
    const result: ReactNodeArray = [];

    if (data) {
      data.scroll_usability.forEach((element, index) => {
        const dataLength = data.scroll_usability.length;
        result.push(
          <HeatmapBarItem
            $width={element.view_rate}
            $height={index !== barCnt - 1 ? barHeight : lastBarHeight}
            onMouseMove={(event) => {
              const { current } = ComponentEl;
              const crossHairElCurrent = CrossHairEl.current;
              const TooltipElCurrent = TooltipEl.current;
              if (current && crossHairElCurrent && TooltipElCurrent) {
                setTooltipInfo({
                  value1: element.avg_attention_time,
                  value2: element.attention_rate,
                  value3: element.view_rate,
                });

                const componentTop =
                  current.getBoundingClientRect().top + window.pageYOffset;

                if (index > dataLength / 2) {
                  // if (!isTooltipOverHalf) {
                  setIsTooltipOverHalf(true);
                  // }

                  TooltipElCurrent.style.top = `${
                    event.pageY -
                    componentTop -
                    TooltipElCurrent.offsetHeight -
                    12
                  }px`;
                } else {
                  // if (isTooltipOverHalf) {
                  setIsTooltipOverHalf(false);
                  // }

                  TooltipElCurrent.style.top = `${
                    event.pageY - componentTop + 12
                  }px`;
                }

                crossHairElCurrent.style.top = `${
                  event.pageY - componentTop
                }px`;
              }
            }}
          />
        );
      });
    }

    return result;
  }, [barHeight, lastBarHeight, data]);

  const printHeatmapLineChart = useMemo(() => {
    const result: ReactNodeArray = [];
    let d = 'M1,0';
    const max = 0.8;
    let maxTime = 0;
    let sumHeight = 0;
    if (data) {
      data.scroll_usability.forEach((element) => {
        maxTime = Math.max(element.avg_attention_time, maxTime);
      });
      data.scroll_usability.forEach((element, index) => {
        const timeRate = (element.avg_attention_time / maxTime) * 100;
        let realWidth = (gradientWidth * (timeRate * max)) / 100;

        if (realWidth === 0) {
          realWidth = 1;
        }

        d += `L${realWidth},${barHeight / 2 + sumHeight} `;

        if (data.scroll_usability.length - 1 === index) {
          d += `L1,${sumHeight + barHeight} `;
        }

        sumHeight += barHeight;
      });
    }

    result.push(
      <HeatmapSVG>
        <path d={d} stroke="white" strokeWidth="2" fill="none" />
      </HeatmapSVG>
    );
    return result;
  }, [barHeight, data]);

  const printTooltip = () => {
    const result: ReactNodeArray = [];
    result.push(
      <TooltipWrapper ref={TooltipEl} $isTooltipOverHalf={isTooltipOverHalf}>
        <TooltipItem>
          <TooltipItemTitle>평균 주목 시간</TooltipItemTitle>
          <TooltipItemValue>{tooltipInfo.value1}초</TooltipItemValue>
        </TooltipItem>
        <TooltipItem>
          <TooltipItemTitle>주목 비율</TooltipItemTitle>
          <TooltipItemValue>{tooltipInfo.value2}%</TooltipItemValue>
        </TooltipItem>
        <TooltipItem>
          <TooltipItemTitle>사용자 도달 비율</TooltipItemTitle>
          <TooltipItemValue>{tooltipInfo.value3}%</TooltipItemValue>
        </TooltipItem>
      </TooltipWrapper>
    );
    return result;
  };

  // 2
  useEffect(() => {
    const barHeightTemp = (gradientHeight * 100) / pageHeight;
    setBarHeight(barHeightTemp);

    setAverageHeightToRenderPixel(
      Math.round((gradientHeight * averageHeight) / pageHeight)
    );

    if (gradientHeight % barHeightTemp !== 0) {
      setLastBarHeight(gradientHeight % barHeightTemp);
    } else {
      setLastBarHeight(barHeightTemp);
    }
  }, [gradientHeight, gradientWidth, pageHeight, data]);

  // 1
  useEffect(() => {
    if (data) {
      setBarCnt(Math.ceil(data.height / 100));
      setpageHeight(data.height);
    }
  }, [data]);

  // 1
  useEffect(() => {
    const { current } = ComponentEl;
    if (current && isPageScreenshotImgLoad) {
      setGradientHeight(current.getBoundingClientRect().height);
      setGradientWidth(current.getBoundingClientRect().width);
    }
  }, [isPageScreenshotImgLoad, ComponentEl.current]);

  return (
    <Component ref={ComponentEl}>
      <PageScreenShotImg
        src={`https://voda-media.nerdfactory.ai/${localStorage.getItem(
          'voda_tenant'
        )}/auto/${pageId}/${encodeURIComponent('page_screenshot')}`}
        ref={pageScreenshotImg}
        onLoad={() => {
          setIspageScreenshotImgLoad(true);
        }}
      />
      <ScreenShotImgBlur />
      <HeatmapWrapper>
        {printHeatmapGradient}
        {printHeatmapLineChart}
        {printHeatmapBar}
        {printTooltip()}
        <CrossHair ref={CrossHairEl} />
      </HeatmapWrapper>
    </Component>
  );
};

export default MouseScrollHeatmap;
